import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dashboard-root text-white font-inter p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center py-20"
}
const _hoisted_6 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-4 gap-4" }
const _hoisted_8 = { class: "glass-card stat-card" }
const _hoisted_9 = { class: "text-3xl font-bold" }
const _hoisted_10 = { class: "glass-card stat-card" }
const _hoisted_11 = { class: "text-3xl font-bold" }
const _hoisted_12 = { class: "glass-card stat-card" }
const _hoisted_13 = { class: "text-3xl font-bold" }
const _hoisted_14 = { class: "glass-card stat-card" }
const _hoisted_15 = { class: "text-3xl font-bold" }
const _hoisted_16 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_17 = { class: "glass-card" }
const _hoisted_18 = { class: "flex items-start justify-between" }
const _hoisted_19 = { class: "mt-3 text-3xl font-bold" }
const _hoisted_20 = { class: "text-sm text-gray-400" }
const _hoisted_21 = { class: "mt-4 space-y-2" }
const _hoisted_22 = { class: "w-28 text-xs text-gray-400" }
const _hoisted_23 = { class: "flex-1 glass-track" }
const _hoisted_24 = { class: "w-10 text-right text-sm" }
const _hoisted_25 = { class: "glass-card" }
const _hoisted_26 = { class: "flex items-start justify-between" }
const _hoisted_27 = { class: "mt-3 text-3xl font-bold" }
const _hoisted_28 = { class: "text-sm text-gray-400" }
const _hoisted_29 = { class: "mt-4 space-y-2" }
const _hoisted_30 = { class: "w-28 text-xs text-gray-400" }
const _hoisted_31 = { class: "flex-1 glass-track" }
const _hoisted_32 = { class: "w-16 text-right text-sm" }
const _hoisted_33 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_34 = { class: "glass-card" }
const _hoisted_35 = { class: "flex items-start justify-between" }
const _hoisted_36 = { class: "mt-3 text-3xl font-bold" }
const _hoisted_37 = { class: "text-sm text-gray-400" }
const _hoisted_38 = { class: "mt-4 space-y-2" }
const _hoisted_39 = { class: "col-span-3 text-xs text-gray-400" }
const _hoisted_40 = { class: "col-span-6 flex items-center gap-2" }
const _hoisted_41 = { class: "flex-1 glass-track" }
const _hoisted_42 = { class: "w-12 text-right text-sm" }
const _hoisted_43 = { class: "col-span-3 text-right text-sm" }
const _hoisted_44 = { class: "glass-card" }
const _hoisted_45 = { class: "flex items-center justify-between" }
const _hoisted_46 = { class: "text-3xl font-bold" }
const _hoisted_47 = {
  key: 0,
  class: "mt-3 grid grid-cols-1 md:grid-cols-2 gap-3"
}
const _hoisted_48 = { class: "font-medium" }
const _hoisted_49 = { class: "text-sm text-gray-300" }
const _hoisted_50 = {
  key: 1,
  class: "text-sm text-gray-500 mt-2"
}
const _hoisted_51 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_52 = { class: "glass-card" }
const _hoisted_53 = { class: "mt-3 text-3xl font-bold" }
const _hoisted_54 = { class: "text-base font-medium text-gray-400" }
const _hoisted_55 = { class: "mt-4 space-y-2" }
const _hoisted_56 = { class: "w-28 text-xs text-gray-400" }
const _hoisted_57 = { class: "flex-1 glass-track relative" }
const _hoisted_58 = { class: "w-20 text-right text-sm" }
const _hoisted_59 = { class: "glass-card" }
const _hoisted_60 = { class: "mt-4 space-y-3" }
const _hoisted_61 = { class: "flex justify-between items-center mb-2" }
const _hoisted_62 = { class: "font-semibold" }
const _hoisted_63 = { class: "text-sm text-gray-300" }
const _hoisted_64 = { class: "glass-track relative" }
const _hoisted_65 = { class: "glass-card" }
const _hoisted_66 = { class: "mt-4 flex items-center gap-4" }
const _hoisted_67 = { class: "flex-1 space-y-2" }
const _hoisted_68 = { class: "flex items-center justify-between" }
const _hoisted_69 = { class: "text-sm" }
const _hoisted_70 = { class: "flex items-center justify-between" }
const _hoisted_71 = { class: "text-sm" }
const _hoisted_72 = { class: "glass-card" }
const _hoisted_73 = {
  key: 0,
  class: "mt-4 space-y-2"
}
const _hoisted_74 = ["title"]
const _hoisted_75 = { class: "flex-1 glass-track" }
const _hoisted_76 = { class: "w-10 text-right text-sm" }
const _hoisted_77 = {
  key: 1,
  class: "text-sm text-gray-500 mt-2"
}
const _hoisted_78 = { class: "glass-card" }
const _hoisted_79 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }

import { onMounted, ref, computed } from 'vue';
import KPIService from '@/service/kpi.service';
import type {
  ActivationMetrics, GoalConfig, RetentionMetrics, WeeklyAcquisitionMetrics, WeeklyRequestsMetrics, TopServiceWeeklyStat, PlatformBreakdown, AcquisitionChannelBreakdown,
} from '@/types/kpi';


export default /*@__PURE__*/_defineComponent({
  __name: 'KPIsDashboard',
  setup(__props) {

const loading = ref(true);
const weeks = ref(8);
const commissionRate = ref(0.15);

const weeklyInstalls = ref<WeeklyAcquisitionMetrics[]>([]);
const activation = ref<ActivationMetrics[]>([]);
const retention = ref<RetentionMetrics[]>([]);
const monetization = ref<{ gmv: number; netRevenue: number }>({ gmv: 0, netRevenue: 0 });
const topline = ref<{ totalUsers: number; totalRequests: number; paidRequests: number; conversionPaidPct: number }>({
  totalUsers: 0, totalRequests: 0, paidRequests: 0, conversionPaidPct: 0,
});
const weeklyRequests = ref<WeeklyRequestsMetrics[]>([]);
const topServices = ref<TopServiceWeeklyStat[]>([]);
const platform = ref<PlatformBreakdown>({ ios: 0, android: 0 });
const paidServicesThisWeek = ref<{ distinctCount: number; services: Array<{ serviceId: string; serviceTitle?: string; paid: number }> }>({ distinctCount: 0, services: [] });
const acquisitionChannels = ref<AcquisitionChannelBreakdown>({});

const goals = ref<GoalConfig>({
  weeklyInstallsTarget: 200,
  activationRateTargetPct: 35,
  wauTarget: 300,
  monthlyBookersTargetPct: 15,
  gmvTarget: 5000,
  netRevenueTarget: 750,
});

const latestInstalls = computed(() => weeklyInstalls.value.at(-1)?.installs ?? 0);
const prevInstalls = computed(() => weeklyInstalls.value.at(-2)?.installs ?? 0);
const installsWoW = computed(() => (prevInstalls.value ? (((latestInstalls.value - prevInstalls.value) / prevInstalls.value) * 100).toFixed(1) : '0'));

const latestActivation = computed(() => activation.value.at(-1)?.activationRatePct ?? 0);
const prevActivation = computed(() => activation.value.at(-2)?.activationRatePct ?? 0);
const activationWoW = computed(() => (prevActivation.value ? (((latestActivation.value - prevActivation.value) / prevActivation.value) * 100).toFixed(1) : '0'));

const latestWAU = computed(() => retention.value.at(-1)?.wau ?? 0);
const latestMonthlyBookersPct = computed(() => retention.value.at(-1)?.monthlyBookersPct ?? 0);

const latestWeeklyRequests = computed(() => weeklyRequests.value.at(-1) || { total: 0, paid: 0, weekLabel: '' });
const maxWeeklyRequests = computed(() => Math.max(1, ...weeklyRequests.value.map((x) => x.total)));
const maxAcquisitionChannel = computed(() => {
  const values = Object.values(acquisitionChannels.value || {});
  if (!values.length) return 1;
  return Math.max(1, ...values);
});

function statusPill(current: number, target: number) {
  if (current >= target) return { text: 'On Track', cls: 'bg-emerald-900/40 text-emerald-300 border-emerald-500/40' };
  const gap = (target - current) / target;
  if (gap <= 0.1) return { text: 'At Risk', cls: 'bg-yellow-900/40 text-yellow-300 border-yellow-500/40' };
  return { text: 'Off Track', cls: 'bg-red-900/40 text-red-300 border-red-500/40' };
}

async function refreshAll() {
  loading.value = true;
  [weeklyInstalls.value, activation.value, retention.value, weeklyRequests.value] = await Promise.all([
    KPIService.getWeeklyInstalls(weeks.value),
    KPIService.getActivationRates(weeks.value, 7),
    KPIService.getRetentionMetrics(weeks.value),
    KPIService.getWeeklyRequests(weeks.value),
  ]);
  monetization.value = await KPIService.getMonetization(30, commissionRate.value);
  topline.value = await KPIService.getTopline();
  topServices.value = await KPIService.getTopServicesWeekly(5);
  platform.value = await KPIService.getPlatformBreakdown();
  paidServicesThisWeek.value = await KPIService.getPaidServicesThisWeek();
  acquisitionChannels.value = await KPIService.getAcquisitionChannelBreakdown();
  loading.value = false;
}

async function loadGoals() {
  goals.value = await KPIService.getGoalsConfig();
}

async function saveGoals() {
  await KPIService.saveGoalsConfig(goals.value);
}

onMounted(async () => {
  await loadGoals();
  await refreshAll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-3xl md:text-4xl font-bold text-gold mb-2" }, "KPIs & Goals"),
          _createElementVNode("p", { class: "text-lg text-gray-300" }, "Acquisition, Activation, Retention, Monetization")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "Weeks", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((weeks).value = $event)),
            class: "glass-input",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (refreshAll()))
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("option", { value: 4 }, "4", -1),
            _createElementVNode("option", { value: 8 }, "8", -1),
            _createElementVNode("option", { value: 12 }, "12", -1)
          ]), 544), [
            [
              _vModelSelect,
              weeks.value,
              void 0,
              { number: true }
            ]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-sm text-gray-300 ml-4" }, "Commission", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            step: "0.01",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commissionRate).value = $event)),
            class: "w-24 glass-input",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (refreshAll()))
          }, null, 544), [
            [
              _vModelText,
              commissionRate.value,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[14] || (_cache[14] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-4 border-gold border-t-transparent" }, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Total Users", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(topline.value.totalUsers), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Total Requests", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(topline.value.totalRequests), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Paid Requests", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(topline.value.paidRequests), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Paid Conversion", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(topline.value.conversionPaidPct) + "%", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Acquisition"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "Weekly Installs")
                  ], -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(['text-xs px-2 py-1 rounded-full border', statusPill(latestInstalls.value, goals.value.weeklyInstallsTarget).cls])
                  }, _toDisplayString(statusPill(latestInstalls.value, goals.value.weeklyInstallsTarget).text), 3)
                ]),
                _createElementVNode("div", _hoisted_19, _toDisplayString(latestInstalls.value), 1),
                _createElementVNode("div", _hoisted_20, "WoW: " + _toDisplayString(installsWoW.value) + "%", 1),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeklyInstalls.value, (pt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pt.weekLabel,
                      class: "flex items-center gap-3"
                    }, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(pt.weekLabel), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", {
                          class: "glass-fill-gold",
                          style: _normalizeStyle({ width: (pt.installs / Math.max(1, Math.max(...weeklyInstalls.value.map(x=>x.installs)))) * 100 + '%' })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(pt.installs), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Activation"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "% new users book within 7 days")
                  ], -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(['text-xs px-2 py-1 rounded-full border', statusPill(latestActivation.value, goals.value.activationRateTargetPct).cls])
                  }, _toDisplayString(statusPill(latestActivation.value, goals.value.activationRateTargetPct).text), 3)
                ]),
                _createElementVNode("div", _hoisted_27, _toDisplayString(latestActivation.value) + "%", 1),
                _createElementVNode("div", _hoisted_28, "WoW: " + _toDisplayString(activationWoW.value) + "%", 1),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activation.value, (pt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pt.cohortLabel,
                      class: "flex items-center gap-3"
                    }, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(pt.cohortLabel), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", {
                          class: "glass-fill-green",
                          style: _normalizeStyle({ width: pt.activationRatePct + '%' })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(pt.activationRatePct) + "%", 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Retention"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "WAU and monthly bookers %")
                  ], -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(['text-xs px-2 py-1 rounded-full border', statusPill(latestWAU.value, goals.value.wauTarget).cls])
                  }, _toDisplayString(statusPill(latestWAU.value, goals.value.wauTarget).text), 3)
                ]),
                _createElementVNode("div", _hoisted_36, "WAU: " + _toDisplayString(latestWAU.value), 1),
                _createElementVNode("div", _hoisted_37, "Monthly bookers: " + _toDisplayString(latestMonthlyBookersPct.value) + "%", 1),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(retention.value, (pt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pt.weekLabel,
                      class: "grid grid-cols-12 gap-3 items-center"
                    }, [
                      _createElementVNode("div", _hoisted_39, _toDisplayString(pt.weekLabel), 1),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", {
                            class: "glass-fill-blue",
                            style: _normalizeStyle({ width: (pt.wau / Math.max(1, Math.max(...retention.value.map(x=>x.wau)))) * 100 + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(pt.wau), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, _toDisplayString(pt.monthlyBookersPct) + "%", 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Paid Services (This Week)"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "Distinct services with at least one paid request")
                  ], -1)),
                  _createElementVNode("div", _hoisted_46, _toDisplayString(paidServicesThisWeek.value.distinctCount), 1)
                ]),
                (paidServicesThisWeek.value.services.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paidServicesThisWeek.value.services, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.serviceId,
                          class: "flex items-center justify-between border border-zinc-700 rounded-lg px-3 py-2"
                        }, [
                          _createElementVNode("div", _hoisted_48, _toDisplayString(s.serviceTitle || s.serviceId), 1),
                          _createElementVNode("div", _hoisted_49, "Paid: " + _toDisplayString(s.paid), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, "No paid services yet this week."))
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex items-start justify-between" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Requests"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "Weekly total vs paid")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_53, [
                  _createTextVNode(_toDisplayString(latestWeeklyRequests.value.total) + " ", 1),
                  _createElementVNode("span", _hoisted_54, "(Paid: " + _toDisplayString(latestWeeklyRequests.value.paid) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeklyRequests.value, (pt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pt.weekLabel,
                      class: "flex items-center gap-3"
                    }, [
                      _createElementVNode("div", _hoisted_56, _toDisplayString(pt.weekLabel), 1),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", {
                          class: "glass-fill-blue",
                          style: _normalizeStyle({ width: (pt.total / maxWeeklyRequests.value) * 100 + '%' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "glass-fill-green absolute top-0 left-0",
                          style: _normalizeStyle({ width: (pt.paid / maxWeeklyRequests.value) * 100 + '%' })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_58, _toDisplayString(pt.paid) + "/" + _toDisplayString(pt.total), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex items-start justify-between" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Top Services (This Week)"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "Most requested, with paid breakdown")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_60, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topServices.value, (s) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: s.serviceId,
                      class: "border border-zinc-700 rounded-lg p-3"
                    }, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(s.serviceTitle || s.serviceId), 1),
                        _createElementVNode("div", _hoisted_63, _toDisplayString(s.paid) + "/" + _toDisplayString(s.total) + " paid", 1)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", {
                          class: "glass-fill-blue",
                          style: _normalizeStyle({ width: (s.total ? (s.total / Math.max(1, ...topServices.value.map(x=>x.total))) * 100 : 0) + '%' })
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "glass-fill-green absolute top-0 left-0",
                          style: _normalizeStyle({ width: (s.paid ? (s.paid / Math.max(1, ...topServices.value.map(x=>x.total))) * 100 : 0) + '%' })
                        }, null, 4)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex items-start justify-between" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Users by Platform"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "iOS vs Android")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_66, [
                  _cache[27] || (_cache[27] = _createStaticVNode("<div class=\"relative w-40 h-40\" data-v-fd853da6><svg viewBox=\"0 0 36 36\" class=\"w-40 h-40\" data-v-fd853da6><defs data-v-fd853da6><linearGradient id=\"gradIOS\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-fd853da6><stop offset=\"0%\" stop-color=\"rgba(0,122,255,0.95)\" data-v-fd853da6></stop><stop offset=\"100%\" stop-color=\"rgba(0,122,255,0.6)\" data-v-fd853da6></stop></linearGradient><linearGradient id=\"gradAndroid\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-fd853da6><stop offset=\"0%\" stop-color=\"rgba(52,199,89,0.95)\" data-v-fd853da6></stop><stop offset=\"100%\" stop-color=\"rgba(52,199,89,0.6)\" data-v-fd853da6></stop></linearGradient></defs><circle cx=\"18\" cy=\"18\" r=\"15.915\" fill=\"rgba(255,255,255,0.06)\" stroke=\"rgba(255,255,255,0.16)\" stroke-width=\"0.5\" data-v-fd853da6></circle><circle cx=\"18\" cy=\"18\" r=\"15.915\" fill=\"transparent\" stroke=\"url(#gradIOS)\" stroke-width=\"3\" stroke-dasharray=\"{{ (platform.ios / Math.max(1, (platform.ios + platform.android))) * 100 }}, 100\" stroke-linecap=\"round\" transform=\"rotate(-90 18 18)\" data-v-fd853da6></circle><circle cx=\"18\" cy=\"18\" r=\"15.915\" fill=\"transparent\" stroke=\"url(#gradAndroid)\" stroke-width=\"3\" stroke-dasharray=\"{{ (platform.android / Math.max(1, (platform.ios + platform.android))) * 100 }}, 100\" stroke-dashoffset=\"-{{ (platform.ios / Math.max(1, (platform.ios + platform.android))) * 100 }}\" stroke-linecap=\"round\" transform=\"rotate(-90 18 18)\" data-v-fd853da6></circle></svg></div>", 1)),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                        _createElementVNode("span", {
                          class: "w-3 h-3 rounded-sm",
                          style: {"background":"linear-gradient(90deg, rgba(0,122,255,0.95), rgba(0,122,255,0.6))"}
                        }),
                        _createElementVNode("span", { class: "text-sm text-gray-300" }, "iOS")
                      ], -1)),
                      _createElementVNode("div", _hoisted_69, _toDisplayString(platform.value.ios), 1)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                        _createElementVNode("span", {
                          class: "w-3 h-3 rounded-sm",
                          style: {"background":"linear-gradient(90deg, rgba(52,199,89,0.95), rgba(52,199,89,0.6))"}
                        }),
                        _createElementVNode("span", { class: "text-sm text-gray-300" }, "Android")
                      ], -1)),
                      _createElementVNode("div", _hoisted_71, _toDisplayString(platform.value.android), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex items-start justify-between" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Users by Acquisition Channel"),
                    _createElementVNode("div", { class: "text-sm text-gray-400" }, "Breakdown by acquisition source")
                  ])
                ], -1)),
                (Object.keys(acquisitionChannels.value).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(acquisitionChannels.value).sort((a, b) => b[1] - a[1]), ([ch, cnt]) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: ch,
                          class: "flex items-center gap-3"
                        }, [
                          _createElementVNode("div", {
                            class: "w-32 text-xs text-gray-300 truncate",
                            title: ch
                          }, _toDisplayString(ch), 9, _hoisted_74),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", {
                              class: "glass-fill-gold",
                              style: _normalizeStyle({ width: (cnt / maxAcquisitionChannel.value) * 100 + '%' })
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_76, _toDisplayString(cnt), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_77, "No acquisition data available."))
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
                _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "text-2xl font-semibold text-gold" }, "Goals", -1)),
                _createElementVNode("button", {
                  class: "glass-button",
                  onClick: saveGoals
                }, "Save")
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "Weekly Installs Target", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((goals.value.weeklyInstallsTarget) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.weeklyInstallsTarget,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "Activation Rate Target (%)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.1",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((goals.value.activationRateTargetPct) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.activationRateTargetPct,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "WAU Target", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((goals.value.wauTarget) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.wauTarget,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "Monthly Bookers Target (%)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.1",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((goals.value.monthlyBookersTargetPct) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.monthlyBookersTargetPct,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "GMV Target (£)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((goals.value.gmvTarget) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.gmvTarget,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "text-sm text-gray-300" }, "Net Revenue Target (£)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((goals.value.netRevenueTarget) = $event)),
                    class: "w-full glass-input"
                  }, null, 512), [
                    [
                      _vModelText,
                      goals.value.netRevenueTarget,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ])
            ])
          ]))
    ])
  ]))
}
}

})